define('translate',['require','lib/sanitizeHtml','translations','underscore'],function(require) {

  var sanitizeHtml = require('lib/sanitizeHtml');
  var translations = require('translations');
  var _ = require('underscore');

  function translate(key) {
    return _.unescape(sanitizeHtml(translations[key]) || sanitizeHtml(key));
  }

  window.t = translate;

  return translate;
});

